import React, { useState, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function ReviewSuccess(props) {

  const { t, i18n } = useTranslation('common');

	useEffect(() => {
		
		if (props?.lan == 'en') {
			i18next.changeLanguage("en");
		} else {
			i18next.changeLanguage("el");
		}
	}, [])


    return (<div>
      
 <div class="container-fluid success_first_section">
      <div class="row ">
        <div class="col success_first_heads" >
         
            <h2 class="success_first_heading">{t('Your review was submitted successfully.')}</h2>
        </div>
      </div>
      </div>
      <div class="container-fluid success_sec_section">
        <div class="row success_sec_rows">
          <div class="col success_sec_heads" >
          
              <h2 class="success_sec_heading">{t('Thank you for your review. Our team will have a look and if it complies with our policy it will be published within 3-5 working days.')}</h2>
          </div>  
        </div>
        </div>
   

    </div>);



}
export default ReviewSuccess;
